// eslint-disable-next-line import/prefer-default-export
export const UpcomingTypes = {
  ADD_STUDY: 'ADD_STUDY',
  ADD_CONTENT: 'ADD_CONTENT',
  ADD_ACTIVE_STUDY: 'ADD_ACTIVE_STUDY',
  COMPLETE: 'COMPLETE',
  TOGGLE_TASK: 'TOGGLE_TASK',
};
